<div class="sch-textarea-wrapper">
  <!-- Top row: Label (left) and Counter (right, only if not embedded) -->
  <div class="sch-textarea-header" *ngIf="label || counterText">
    <label
      *ngIf="label"
      class="sch-input-label {{ variant }}"
      for="{{ id }}"
      [attr.readonly]="readonly"
      [attr.disabled]="disabled"
    >
      {{ label }}
    </label>
    
    <div
      *ngIf="!embedCounter && limitCharacters && maxLength"
      class="sch-textarea-counter-external {{ counterClass }}"
      aria-live="polite"
    >
      {{ counterText }}
    </div>
  </div>

  <!-- Textarea container -->
  <div class="sch-textarea-container">
    <textarea
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="minRows"
      [cdkAutosizeMaxRows]="maxRows"
      [id]="id"
      (isValid)="handleValidation($event)"
      [value]="value"
      [currentValue]="value"
      (input)="onInput($event)"
      (blur)="inputBlurred()"
      [autocomplete]="autocomplete"
      class="sch-text-area {{ variant }}"
      [class.has-value]="value"
      [class.has-placeholder]="placeholder"
      [class.has-embedded-counter]="embedCounter && limitCharacters && maxLength"
      [placeholder]="readonly ? readonlyplaceholder : placeholder"
      [readonly]="readonly"
      [disabled]="disabled"
      [maxLength]="maxLength"
      [threshold]="threshold"
      [embedCounter]="false"
      [allowExceed]="allowExceed"
      [sch-character-limit]="readonly ? false : limitCharacters"
      (characterLimitReached)="onCharacterLimitReached()"
      (characterLimitExceeded)="onCharacterLimitExceeded($event)"
      (counterStateChange)="counterTextChange($event)"
    >
    </textarea>
    
    <!-- Embedded counter at bottom-right inside textarea -->
    <div
      *ngIf="embedCounter && limitCharacters && maxLength"
      class="sch-textarea-counter-embedded {{ counterClass }}"
      aria-live="polite"
    >
      {{ counterText }}
    </div>
  </div>
</div>
